var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMuteCross = function SvgIconMuteCross(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.41 28.59 11 25 14.59 21.41 11 20 12.41 23.59 16 20 19.59 21.41 21 25 17.41 28.59 21 30 19.59 26.41 16z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMuteCross);
export { ForwardRef as ReactComponent };